import { SwiperSlide } from '@/components/Carousels/SwiperCarousel';

// STYLES
import ChannelsCarouselStyled from './styles';

export { SwiperSlide as ChannelsCarouselSlide };
export default ChannelsCarouselStyled;
